import React from "react";
import { formatGBP } from "../../utils/currency";

interface PropsType {
  [x: string]: any;
}
export default function WithdrawalCalculation(props: PropsType) {
  return (
    <div className="calculation_box">
      <div className="calculation_main">
        <p>
          Current Withdrawal:{" "}
          <span>
            {formatGBP(props.calculatedData?.currentRegularWithdrawal)}
          </span>
        </p>
        <p>
          Frequency: <span>{props.calculatedData?.currentFrequency}</span>
        </p>
        <p>
          Single Withdrawal:{" "}
          <span>{formatGBP(props.calculatedData?.totalSinglePremiums)}</span>
        </p>
        <p>
          Total Withdrawn to Date:{" "}
          <span>{formatGBP(props.calculatedData?.totalPaidToDate)}</span>
        </p>
        <p>
          Current Monthly Withdrawal:{" "}
          <span>{formatGBP(props.calculatedData?.currentRegular)}</span>
        </p>
      </div>
    </div>
  );
}
